import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { TableConfigurationModel } from '../../../core/models/table/table-configuration.model';
import { ActionIdEnum } from '../../../core/enums/list-layout/action-id-enum';
import { BaseModel } from 'src/app/core/models/base.model';
import { ColumnTypeEnum } from '../../../core/enums/list-layout/column-type-enum';
import { Observable } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { ButtonTypeEnum } from '../../../core/enums/list-layout/button-type-enum';
import { ServiceData } from '../../../core/models/table/service-data.model';
import { TableActionsModel } from '../../../core/models/table/table-action.model';
import { EmitSortModel } from '../../../core/models/table/emit-sort.model';
import { SortByTypeEnum } from '../../../core/enums/list-layout/sort-type-enum';
import { AccountStatus } from 'src/app/core/models/members/user/user.model';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { environment } from 'src/environments/environment';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { CustomStatusTableConfigEnum } from 'src/app/core/enums/list-layout/custom-status-table-config-enum';
import { ArrayModels } from 'src/app/core/models/table/list-layout-models/arrays.model';
import { CustomStatusDisplay } from 'src/app/core/models/table/list-layout-models/custom-status-display.model';
import { SwitchOptions } from 'src/app/core/models/table/list-layout-models/switch-options.model';
import { CustomDateDisplayEnum } from 'src/app/core/enums/list-layout/custom-date-display-enum';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { OffcanvasDismissEnum } from 'src/app/core/enums/offcanvas-dismiss-enum';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { DefaultImageService } from 'src/app/core/services/default-image.service';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { ListAdjustmentService } from 'src/app/core/services/modal-services/list-adjustment.service';

@Component({
  selector: 'app-list-layout',
  templateUrl: './list-layout.component.html',
  styleUrls: ['./list-layout.component.scss']
})
export class ListLayoutComponent {

  enumActionId = ActionIdEnum;
  enumButtonType = ButtonTypeEnum;
  maxListHeight = 670;

  protected defaultImageService: DefaultImageService = new DefaultImageService();

  protected total!: Observable<number>;
  protected isLoading!: Observable<Boolean>;
  protected showFilterAndSearchArea: boolean = false;
  protected masterSelected!: boolean;

  emitSortModel: EmitSortModel = new EmitSortModel(SortByTypeEnum.None, undefined);
  enumColumnType = ColumnTypeEnum;
  timeout: any = null;

  searchTermContainsInvalidCharacters: boolean = false;
  searchTermInvalidCharactersArray: string[] = ['[', ']', '{', '}', '(', ')', '*', '\\', '|'];
  searchTermInvalidCharacterMessage: string = `Search term contains one or more invalid characters. Invalid characters are: [ ] { } ( ) * \\ |`;

  displaySearchFilterOptions: boolean = false;

  @Input() public tableConfig: TableConfigurationModel = new TableConfigurationModel();
  @Input() public defaultTableConfig: TableConfigurationModel | undefined = undefined;

  @Input() public listItems: any[] = [];
  @Input() public sortBy: any;
  @Input() public serviceData: ServiceData = new ServiceData;
  @Input() public checkedValGet: any[] = [];
  @Output() public rowActionSelected = new EventEmitter<TableActionsModel>;
  @Output() public sortSelected = new EventEmitter<EmitSortModel>;
  @Output() public filterSelected = new EventEmitter<any>;
  @Output() public buttonActionSelected = new EventEmitter<any>;
  @Output() public searchTermChanged = new EventEmitter<string>;
  @Output() public dateRangeChanged = new EventEmitter<string>;
  @Output() public paginationSelected = new EventEmitter<number>;
  @Output() public pageSizeSelected = new EventEmitter<number>;
  @Output() public updateCheckedValues = new EventEmitter<any>;
  @Output() public updateListConfig = new EventEmitter<any>;
  @Output() public resetListLayout = new EventEmitter<boolean>;
  @Output() public searchTermFilterSelected = new EventEmitter<any>;

  constructor(
    private offcanvasService: NgbOffcanvas,
    protected listAdjustmentService: ListAdjustmentService,
    protected authMyFileService: AuthMyfileService
  ) { }

  public ngOnInit() {
    console.log(this.tableConfig)
    if (this.tableConfig.customizedListTitle && this.tableConfig.customizedListTitle.length > 0) {
      this.tableConfig.listTitle = JSON.parse(JSON.stringify(this.tableConfig.customizedListTitle));
    } else {
      if (this.tableConfig.listTitle) {
        this.tableConfig.listTitle = JSON.parse(JSON.stringify(this.tableConfig.listTitle));
      }
    }

    this.showFilterAndSearchArea = this.determineIfSearchBarAreaIsVisible();
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.tableConfig.columns.sort((a, b) => a.order - b.order);
    this.checkedValGet = [];
    this.masterSelected = false;
  }

  public onRowActionClicked(actionType: ActionIdEnum | undefined, model: BaseModel, index: number, listItems?: any): void {

    if (listItems !== undefined) {
      model = listItems[index];
    }

    if (actionType) {
      var rowActionsModel = new TableActionsModel(model, actionType, index);
    } else {
      var rowActionsModel = new TableActionsModel(model, ActionIdEnum.None, index);
    }

    this.rowActionSelected.emit(rowActionsModel);
  }

  public onCheckBoxButtonClicked(buttonIdEnum: ButtonIdEnum | undefined): void {
    var checkedButtonModelEmit = { buttonId: buttonIdEnum, checkedValList: this.checkedValGet };
    this.buttonActionSelected.emit(checkedButtonModelEmit);
  }

  columnData(columnDataFieldName: string | undefined, dataModel: any): any {
    if (dataModel != undefined && columnDataFieldName && (dataModel[columnDataFieldName] !== undefined)) {
      return dataModel[columnDataFieldName];
    }
    return '';
  }

  onInlineUpdate(event: any, columnDataFieldName: string | undefined, dataModel: any, listItems: any, index: number) {
    if (columnDataFieldName !== undefined && dataModel[columnDataFieldName] !== undefined) {
      dataModel[columnDataFieldName] = event;
    }
    listItems[index] = dataModel;
  }

  inputFieldEnabled(index: number | undefined): boolean {
    //the returns seemed reversed since [disabled] is disabled when true is returned. 
    if (this.tableConfig.activeInputFieldIndex !== undefined && this.tableConfig.activeInputFieldIndex === index) {
      return false;
    } else {
      return true;
    }
  }

  profilePhotoPNGTransform(profilePhoto: any) {
    if (profilePhoto && profilePhoto.listPhoto) {
      return profilePhoto.listPhoto;
    }
    if (profilePhoto !== undefined) {
      profilePhoto.listPhoto = this.defaultImageService.getDefaultUserImage(profilePhoto.fullName);
      return profilePhoto.listPhoto;
    }
    return this.defaultImageService.getDefaultUserImage();
  }

  renameFileSize(filesize: string): string {
    if (filesize.length == 0) {
      return '0 Bytes'
    }
    const k = 1000
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(Number(filesize)) / Math.log(k))
    return `${parseFloat((Number(filesize) / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
  }

  getIfVisibleStatus(isVisibleValue: boolean | string | undefined): boolean {
    if (typeof (isVisibleValue) == 'boolean') {
      return isVisibleValue;
    } else if (isVisibleValue === undefined) {
      return true;
    } else if (typeof (isVisibleValue) == 'string') {
      if (isVisibleValue === 'true') {
        return true;
      } else if (isVisibleValue === 'false') {
        return false;
      } else {
        return this.authMyFileService.canAccessOperation(isVisibleValue);
      }
    } else {
      return false;
    }
  }

  getDocumentImageUrl(requisitionURL: string | undefined): string {

    if (requisitionURL) {
      var filename = requisitionURL.split('/').pop();

      if (filename && filename.includes("120.png")) {
        filename = GlobalComponent.defaultMyfileNameImage;
      }

      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

  dateRename(date: String | undefined, format?: CustomDateDisplayEnum) {
    if (date !== undefined && date.length > 0) {
      if (format !== undefined) {
        var dateStringArray = date.split('-');
        var dateDay = dateStringArray[2].split('T')[0]
        var dateMonth = dateStringArray[1];
        var dateYear = dateStringArray[0];
        switch (format) {
          case CustomDateDisplayEnum.DMY_Dashes:
            return `${dateDay}-${dateMonth}-${dateYear}`
          case CustomDateDisplayEnum.MDY_Dashes:
            return `${dateMonth}-${dateDay}-${dateYear}`
          case CustomDateDisplayEnum.YMD_Dashes:
            return `${dateYear}-${dateMonth}-${dateDay}`
          case CustomDateDisplayEnum.DMY_Slashes:
            return `${dateDay}/${dateMonth}/${dateYear}`
          case CustomDateDisplayEnum.MDY_Slashes:
            return `${dateMonth}/${dateDay}/${dateYear}`
          case CustomDateDisplayEnum.YMD_Slashes:
            return `${dateYear}/${dateMonth}/${dateDay}`
          default:
            return GlobalComponent.dateTransform(date.toString(), false)
        }
      } else {
        return GlobalComponent.dateTransform(date.toString(), false)
      }
    } else {
      return '';
    }
  }


  selectRow(model: any, index: number) {
    if (this.tableConfig.doubleClickSelect && this.tableConfig.doubleClickSelect.enabled) {
      if (model.checkBoxState) {
        this.onRowActionClicked(this.tableConfig.doubleClickSelect!.action, model, index)
      } else {
        model.checkBoxState = true;
        var checkedVal = [];
        for (var i = 0; i < this.listItems.length; i++) {
          if (this.listItems[i].checkBoxState == true) {
            checkedVal.push(this.listItems[i]);
          }
        }
        this.checkedValGet = checkedVal;
        this.updateCheckedValues.emit(this.checkedValGet);
      }
    }
  }

  determineIfSearchBarAreaIsVisible(): boolean {


    if (this.tableConfig.searchbarFilter != undefined) {
      return true;
    }

    var result: boolean = false;

    if (this.tableConfig.filters != undefined && this.tableConfig.filters.length > 0) {
      this.tableConfig.filters.forEach((filterOptions: ListFilterModel) => {
        if (result == false) {
          if (filterOptions.isHidden !== true) {
            if (filterOptions.inButton || filterOptions.inDropdown) {
              result = true;
            }
          }
        }
      })
    }

    return result;
  }

  stopPropagationOnClick($event: MouseEvent) {
    $event.stopPropagation();
  }

  checkUncheckAll(ev: any, list: any) {
    list.forEach((x: { checkBoxState: any; }) => x.checkBoxState = ev.target.checked)
    var checkedVal: any[] = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].checkBoxState == true) {
        checkedVal.push(list[i]);
      }
    }
    this.checkedValGet = checkedVal;
    this.updateCheckedValues.emit(this.checkedValGet);
  }


  onCheckboxChange(e: any, list: any) {
    var checkedVal: any[] = [];
    var result: any = undefined;
    for (var i = 0; i < list.length; i++) {
      if (list[i].checkBoxState == true) {
        result = list[i];
        checkedVal.push(result);
      }
    }
    this.checkedValGet = checkedVal;

    if (list.length && list.length > 0 && this.checkedValGet.length === list.length) {
      this.masterSelected = true;
    } else {
      this.masterSelected = false;
    }
    this.updateCheckedValues.emit(this.checkedValGet);
  }

  showAction(visibleOnValues: any[], data: any, dataFieldName: string | undefined, visibilityByValueIsEnum: boolean | undefined, visibilityByContainsSubString: boolean | undefined, subStringDataFieldName: string | undefined, visibilitySubString: string | undefined, label: any, filename: any): boolean {

    var visibilityOfAction: boolean = false;

    var columnData = this.columnData(dataFieldName, data);

    if (visibilityByValueIsEnum) {
      //Needs to be number cause some Enums are 0, which JS can read as undefined, which fails to find.
      visibilityOfAction = visibleOnValues.includes(Number(columnData));
    } else {
      visibilityOfAction = visibleOnValues.includes(`${columnData}`);
    }

    if (visibilityOfAction !== false) {

      if (visibilityByContainsSubString !== undefined && visibilitySubString !== undefined && subStringDataFieldName !== undefined && columnData !== undefined && columnData.length > 0) {
        var subStringData = this.columnData(subStringDataFieldName, data)
        if (visibilityByContainsSubString) {
          return this.containsSubString(subStringData, visibilitySubString);
        } else {
          return !this.containsSubString(subStringData, visibilitySubString);
        }
      }
    }

    return visibilityOfAction;
  }

  // this searchTerm call function implements a search call delay using timeout and setTimeout() so that we prevent irrelevant api calls, the actual call is done half a second after a user stops typing via the searchTermChanged.emit()
  searchTermUpdated() {
    if (this.tableConfig.searchbarFilter) {
      this.searchTermContainsInvalidCharacters = false;
      if (this.tableConfig.searchbarFilter!.value && this.tableConfig.searchbarFilter!.value.length > 0) {
        this.searchTermInvalidCharactersArray.forEach(invalidChar => {
          if (this.tableConfig.searchbarFilter!.value.includes(invalidChar)) {
            this.searchTermContainsInvalidCharacters = true;
          }
        })
      }
      if (this.searchTermContainsInvalidCharacters == false) {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          if (this.tableConfig.searchbarFilter!.value.length == 0) {
            this.searchTermChanged.emit(undefined);
          } else {
            this.searchTermChanged.emit(this.tableConfig.searchbarFilter!.value);
          }
        }, 500);
      }
    }
  }

  clearSearchSelected() {
    if (this.tableConfig.searchbarFilter) {
      this.searchTermContainsInvalidCharacters = false;
      this.tableConfig.searchbarFilter.value = '';
      if (this.tableConfig.searchbarFilter.filter) {
        this.tableConfig.searchbarFilter.filter.selectedOptions = [];
      }
      this.searchTermChanged.emit(undefined)
    }
  }

  renameDataTimeSpent(time: number): string {
    var timeMin: any = time % 60;
    var timeHours = (time - timeMin) / 60;
    if (timeMin < 10) {
      timeMin = `0${timeMin}`
    }
    return `${timeHours}:${timeMin}`
  }


  tabulateTotal(columnDataFieldName: string | undefined, title: string | undefined, columnNameForCheck?: string, columnTwoComparisonValue?: string): string {
    if (columnDataFieldName) {
      if ((columnTwoComparisonValue != undefined) && (columnNameForCheck != undefined)) {
        if (this.listItems && this.listItems.length > 0) {
          var total: number = 0;
          this.listItems.forEach((items: any) => {
            if (this.columnData(columnNameForCheck, items) == columnTwoComparisonValue) {
              total = total + Number(this.columnData(columnDataFieldName, items));
            } else {
              total = total - Number(this.columnData(columnDataFieldName, items));
            }
          })

          return `${title}${total.toFixed(2)}`;
        }
      } else {
        if (this.listItems && this.listItems.length > 0) {
          var total: number = 0;
          this.listItems.forEach((items: any) => {
            total = total + Number(this.columnData(columnDataFieldName, items));
          })
          return `${title}${total.toFixed(2)}`;
        }
      }
    }
    return ''
  }

  dateUpdated(event: any) {
    if (this.tableConfig.dateFilter) {
      if (event.selectedDates.length == 2) {
        this.tableConfig.dateFilter.dateRange.from = event.selectedDates[0];
        this.tableConfig.dateFilter.dateRange.to = event.selectedDates[1];
        this.dateRangeChanged.emit(this.tableConfig.dateFilter.dateRange);
      }
    }
  }

  clearDateSelected() {
    if (this.tableConfig.dateFilter) {
      this.tableConfig.dateFilter.dateRange = '';
      this.dateRangeChanged.emit(undefined)
    }
  }

  checkIfDateFilterExists(dateRangeModel: any) {
    if (dateRangeModel !== undefined && dateRangeModel.from !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  openListAdjustmentModal() {
    this.listAdjustmentService.openModal(this.tableConfig, this.defaultTableConfig);
    var sub = this.listAdjustmentService.modelChanged.subscribe((newConfig) => {

      this.pageSizeSelected.emit(Number(this.tableConfig.pageSize));

      this.tableConfig.columns = newConfig.columns;

      this.updateListConfig.emit(this.tableConfig);

      sub.unsubscribe();
    })
  }

  reloadListAdjustmentModal() {
    this.resetListLayout.emit(true);
  }

  onNavChange(filterIndex: number, event: any) {
    if (this.tableConfig.filters) {
      this.tableConfig.filters[filterIndex].selectedOption = this.tableConfig.filters[filterIndex].options[event.nextId].value;
      this.filterSelected.emit(this.tableConfig.filters[filterIndex]);
    }
  }

  onFilterClicked(filterIndex: number, optionIndex: number) {
    if (this.tableConfig.filters) {
      this.tableConfig.filters[filterIndex].selectedOption = this.tableConfig.filters[filterIndex].options[optionIndex].value;
      this.filterSelected.emit(this.tableConfig.filters[filterIndex]);
    }
  }

  filterSelectedEmit(filterIndex: number, event: any) {
    if (this.tableConfig.filters) {
      this.tableConfig.filters[filterIndex].selectedOption = event.value;
      this.filterSelected.emit(this.tableConfig.filters[filterIndex]);
    }
  }

  pagingInfo() {
    let from = this.serviceData.pageIndex == 0 ?
      (this.serviceData.pageSize * this.serviceData.pageIndex) + 1
      : this.serviceData.pageSize * this.serviceData.pageIndex;

    let to = (this.serviceData.pageSize * this.serviceData.pageIndex) + this.serviceData.pageSize;

    if (to > this.serviceData.totalRecords) {
      to = this.serviceData.totalRecords;
    }

    if ((from <= 0) || (this.serviceData.totalRecords === 0)) {
      from = 0;
    }

    if (this.serviceData.totalRecords === 0) {
      this.serviceData.page = 0;
    }
    if (this.serviceData.page === 0 && this.serviceData.totalRecords !== 0) {
      this.serviceData.page = 1;
    }

    return `Showing ${from} to ${to} of ${this.serviceData.totalRecords} records`;
  }

  containsSubString(input: String, subString: string): boolean {
    if (input.includes(subString)) {
      return true;
    }
    return false
  }

  selectPage(page: string) {
    this.serviceData.page = parseInt(page, 10) || 1;
    this.paginationSelected.emit(this.serviceData.page);
  }

  emitSortBy(sort: SortByTypeEnum, fieldName: string | undefined, altSortFieldName?: string) {
    if (altSortFieldName) {
      this.emitSortModel.fieldName = altSortFieldName;
    } else {
      this.emitSortModel.fieldName = fieldName;
    }
    this.emitSortModel.sortSelected = sort;
    this.sortSelected.emit(this.emitSortModel);
  }

  FILTER_PAG_REGEX = /[^0-9]/g;
  formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(this.FILTER_PAG_REGEX, '');
  }

  statusTextClass(status: AccountStatus | undefined) {
    switch (status as AccountStatus) {
      case AccountStatus.Approved:
        return 'coloredTextArea green';
      case AccountStatus.Disabled:
        return 'coloredTextArea red';
      case AccountStatus.Pending:
        return 'coloredTextArea orange';
      case AccountStatus.Onboarding:
        return 'coloredTextArea purple';
      case AccountStatus.PasswordReset:
        return 'coloredTextArea blue';
      default:
        return '';
    }
  }

  statusText(status: AccountStatus) {
    switch (status as AccountStatus) {
      case AccountStatus.Approved:
        return $localize`:@@Status_Text_Approved:Approved`;
      case AccountStatus.Disabled:
        return $localize`:@@Status_Text_Disabled:Disabled`;
      case AccountStatus.Pending:
        return $localize`:@@Status_Text_Pending:Pending`;
      case AccountStatus.Onboarding:
        return $localize`:@@Status_Text_Onboarding:Onboarding`;
      case AccountStatus.PasswordReset:
        return $localize`:@@Status_Text_PasswordReset:Password Reset`;
      default:
        return '';
    }
  }

  selectButtonArrayClass(filter: ListFilterModel, filterOption: NgSelectListModel, index: number) {

    var returnString = '';

    if (filter.selectedOption == filterOption.value) {
      returnString = 'selectedButtonArray'
    } else {
      returnString = 'unSelectedButtonArray'
    }

    if (filter.selectedOption == undefined) {
      if (filterOption.default === true) {
        returnString = 'selectedButtonArray'
      }
    }

    if (index == 0) {
      returnString = returnString + " buttonStart"
    } else
      if ((index + 1) == filter.options.length) {
        returnString = returnString + " buttonEnd"
      } else {
        returnString = returnString + " buttonMiddle"
      }

    return returnString;
  }
  customStatus(customStatusDisplay: CustomStatusDisplay | undefined, dataFieldName: any, data: any, isArray?: boolean): string {

    var output: any = undefined;
    if ((dataFieldName !== undefined && data !== undefined) || isArray === true) {
      var check: any;
      if (isArray !== true) {
        check = this.columnData(dataFieldName, data);
      } else {
        check = data;
      }

      var inverseArray: boolean = false;
      customStatusDisplay?.switchOptions.forEach((switchOption: SwitchOptions) => {

        //this takes care of all general layouts so it does need Type verification. type: ColumnTypeEnum.StatusCustom, <- all of these. Since it just checks if the data type is equal to the type expected. 
        //To Do: Need to varify this works with all lists since now switchOption.case are stored as Strings not enums, and server returns enum. 
        if (check == switchOption.case) {
          output = switchOption.return;
        }

        //this section only triggers when data is not found in first batch also know as type: ColumnTypeEnum.StatusCustomArray, - only current found in the Table-File-management list config. 
        if (output === undefined) {
          switch (switchOption.case as CustomStatusTableConfigEnum | undefined) {
            case undefined:
              output = switchOption.return;
              return output;
            case CustomStatusTableConfigEnum.AnyInput:
              if (check !== undefined && check.length > 0) {
                output = switchOption.return;
              }
              return output;
            case CustomStatusTableConfigEnum.ReturnData:
              if (check !== undefined && check.length > 0) {
                output = check;
              } else {
                output = switchOption.return;
              }
              return output;
            case CustomStatusTableConfigEnum.CheckFirstCharacter:
              inverseArray = true;
              if (check !== undefined && check.length > 0) {

                if (switchOption.delimiterExceptionWords !== undefined && switchOption.delimiterExceptionWords.length > 0) {
                  switchOption.delimiterExceptionWords.forEach((exception: string) => {
                    if (exception === check.toString()) {
                      if (switchOption.return === undefined) {
                        output = check;
                      } else {
                        output = switchOption.return;
                      }
                    }
                  });
                }

                if (switchOption.delimiter && output === undefined) {
                  if (!check.toString().startsWith(switchOption.delimiter)) {
                    if (switchOption.return === undefined) {
                      output = check;
                    } else {
                      output = switchOption.return;
                    }
                  }
                }

              }
              return output;
          }
        }
      });
    }
    return output;
  }

  customColorIcon(actionColor: String | undefined) {
    if (actionColor !== undefined) {
      return actionColor;
    }

    return `text-muted`;
  }

  modelsArray(entityType: EntityTypeEnum, arrayModels: ArrayModels[], model: any): any {
    if (arrayModels.length > 1) {
      var output: any = undefined;
      arrayModels.forEach((arrayModel: ArrayModels) => {
        if (arrayModel.entityType == entityType) {
          output = this.columnData(arrayModel.model.mainDataFieldName, model);
        }
      })
      return output;
    } else {
      return this.columnData(arrayModels[0].model.mainDataFieldName, model);
    }
  }

  openEnd(content: TemplateRef<any>) {
    var canvasRef = this.offcanvasService.open(content, { position: 'end', backdrop: false });

    var sub = canvasRef.dismissed.subscribe((event: OffcanvasDismissEnum) => {
      switch (event) {
        case OffcanvasDismissEnum.Background:
          this.applySearchbarFilterOption(true);
          break;
        case OffcanvasDismissEnum.CrossClick:
          this.applySearchbarFilterOption(true);
          break;
      }
      sub.unsubscribe();
    })
  }

  applySearchbarFilterOption(dismiss?: boolean) {
    this.tableConfig.searchbarFilter!.filter!.selectedOptions = [];

    this.tableConfig.searchbarFilter!.filter!.sections!.forEach((section) => {
      section.options!.forEach(selectedOption => {
        if (selectedOption.isSelected == true) {
          this.tableConfig.searchbarFilter!.filter!.selectedOptions.push(selectedOption.value);
        }
      });
    });
    this.searchTermFilterSelected.emit(this.tableConfig.searchbarFilter!.filter!.selectedOptions);
    if (dismiss) {
      this.offcanvasService.dismiss(OffcanvasDismissEnum.Apply);
    }
  }

  clearSearchbarFilterOption() {
    this.tableConfig.searchbarFilter!.filter!.selectedOptions = [];
    this.tableConfig.searchbarFilter!.filter!.sections!.forEach((section) => {
      section.options!.forEach(selectedOption => {
        selectedOption.isSelected = false;
      });
    });
    this.searchTermFilterSelected.emit(this.tableConfig.searchbarFilter!.filter!.selectedOptions);
    this.offcanvasService.dismiss(OffcanvasDismissEnum.Clear);
  }
}
